import axios from 'axios';

const normalizedUrl = (url) => String(url || 'http://127.0.0.1:9876').replace(/\/$/, '');
const client = (configuration) => axios.create({
  baseURL: normalizedUrl(configuration?.agentUrl),
  timeout: 1200,
  headers: {
    'Content-Type': 'application/json',
    ...(configuration?.pairingToken ? { 'X-VFD-Token': configuration.pairingToken } : {}),
  },
});
const call = async (configuration, method, path, data) => (await client(configuration).request({ method, url: `/api/v1/${path}`, data })).data;
const connectionPayload = (c) => ({ protocol:c.protocol,serialPort:c.serialPort,baudRate:c.baudRate,dataBits:c.dataBits,stopBits:c.stopBits,parity:c.parity,rows:c.rows,columns:c.columns,charset:c.charset,autoReconnect:c.autoReconnect });

const vfdAgentClient = {
  status: (c) => call(c, 'get', 'status'),
  ports: (c) => call(c, 'get', 'ports'),
  connect: (c) => call(c, 'post', 'connect', connectionPayload(c)),
  disconnect: (c) => call(c, 'post', 'disconnect', {}),
  display: (c, payload) => call(c, 'post', 'display', payload),
  welcome: (c, line1 = c.idleLine1, line2 = c.idleLine2) => call(c, 'post', 'welcome', { line1, line2 }),
  clear: (c) => call(c, 'post', 'clear', {}),
  test: (c) => call(c, 'post', 'test', {}),
};
export default vfdAgentClient;
